<template>
  <div
    class="bg-white mb-[24px]"
  >
    <!-- Header -->
    <div class="flex items-center justify-between gap-[8px] mb-[24px] px-[20px] py-[16px] border-b-[1px] border-b-[#E5E5E5]">
      <div class="flex items-center gap-[8px] shrink-1">
        <Button
          outline
          type="icon"
          @click="$router.go(-1)"
        >
          <span class="k-arrow-left-2 text-[#0A0A0A]" />
        </Button>
        <span class="text-[#0A0A0A] font-semibold">
          Detail Order Packing
        </span>
      </div>
    </div>

    <!-- Info Card -->
    <div
      class="border rounded-[12px] mx-[24px] p-[16px] mb-[24px]"
      :class="{ 'animate-pulse': loading }"
    >
      <div class="grid sm:grid-cols-3 gap-[24px] text-[14px] text-[#0A0A0A]">
        <div class="flex items-start justify-start flex-col gap-[4px]">
          <div
            class="font-medium mb-[4px]"
            :class="loading ? 'text-transparent bg-[#E5E5E5] rounded w-2/5' : ''"
          >
            Tanggal Order
          </div>
          <div :class="loading ? 'text-transparent bg-[#E5E5E5] rounded w-3/5' : ''">
            {{ generalInfo.order_date }}
          </div>
          <div
            class="capitalize text-[12px]"
            :class="loading ? 'text-transparent bg-[#E5E5E5] rounded w-2/4' : 'text-[#737373]'"
          >
            {{ generalInfo.order_time }}
          </div>
        </div>
        <div class="flex items-start justify-start flex-col gap-[4px]">
          <div
            class="font-medium mb-[4px]"
            :class="loading ? 'text-transparent bg-[#E5E5E5] rounded w-2/5' : ''"
          >
            Outbound ID
          </div>
          <div :class="loading ? 'text-transparent bg-[#E5E5E5] rounded w-3/5' : ''">
            {{ generalInfo.id }}
          </div>
          <div
            class="text-[12px]"
            :class="loading
              ? 'text-transparent bg-[#E5E5E5] rounded w-4/5'
              : (orderData.printed_at ? 'text-[#3B82F6]' : 'text-[#DC2626]')"
          >
            {{ generalInfo.printed_at }}
          </div>
        </div>
        <div class="flex items-start justify-start flex-col gap-[8px]">
          <div
            class="font-medium"
            :class="loading ? 'text-transparent bg-[#E5E5E5] rounded w-2/5' : ''"
          >
            Status Outbound
          </div>
          <StatusPackingPill
            :status="generalInfo.status"
            :disabled="true"
            :class="loading ? 'opacity-0 pointer-events-none' : ''"
          />
        </div>
      </div>
    </div>

    <!-- Info Banner -->
    <div
      class="flex items-center rounded-[14px] p-[12px] justify-start gap-[6px] mx-[24px] mb-[24px]"
      :class="loading ? 'bg-[#E5E5E5] animate-pulse' : 'bg-[#EFF6FF]'"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/svg/info-circle.svg"
        alt="info-circle"
        width="16"
        height="16"
        :class="loading ? 'opacity-0' : ''"
      >
      <span
        class="text-[14px]"
        :class="loading ? 'text-transparent bg-[#D4D4D4] rounded w-4/5' : 'text-[#0A0A0A]'"
      >
        Pastikan pesanan sejalan dengan label pengiriman. Checklist orderan yang sesuai dengan label pengiriman. Jika ada orderan yang tak sesuai atau resi berlebih, langsung hubungi partner untuk pengajuan susulan. Kita selalu siap membantu!
      </span>
    </div>

    <!-- Download Label Button -->
    <div class="mx-[24px] mb-[16px] flex items-center justify-end">
      <Button
        :variant="isOrderDibatalkan ? '' : 'primary'"
        :disabled="orderData.label_url === '' || isOrderDibatalkan || loading || loadingDownloadLabel"
        :class="[
          (orderData.label_url === '' || isOrderDibatalkan) ? 'cursor-not-allowed' : '',
          loading ? 'opacity-0 pointer-events-none' : '',
        ]"
        class="flex items-center justify-center gap-[8px]"
        @click="handleDownloadLabel(orderData.label_url)"
      >
        <b-spinner
          v-if="loadingDownloadLabel"
          small
        />
        Download Label
      </Button>
    </div>

    <div class="px-[24px] pb-[24px] border-b-[1px] border-[#E5E5E5] mb-[24px]">
      <Table
        :batch-status="orderData.status"
        :items="orderData.order_summary"
        :loading="loading"
        :packing-can-be-updated="orderData.status === 'Belum Dipacking'"
        :outbound-operations="outboundOperations"
      />
    </div>

    <ResumeFee
      ref="resumeFee"
      :loading="loading"
      :can-be-updated="orderData.status === 'Belum Dipacking'"
    />

    <div class="flex justify-end mx-[24px] pb-[100px]">
      <ButtonPackingProduk
        ref="buttonPackingProduk"
        @packing="handlePackingProduct"
      />
    </div>

    <ModalConfirm
      ref="modalConfirm"
      @on-close="handleCloseModalConfirm"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { toastError } from '@/libs/toastification'
import { DAY_FULL_DATE_TIME, DAY_MONTH_YEAR, TIME_DOT } from '@/libs/filterDate'
import ModalConfirm from '@/views/components/modal/ModalConfirm.vue'
import {
  Button,
} from '@/@core/components/ui'
import Table from './Table.vue'
import ResumeFee from './ResumeFee.vue'
import { modalMessagesMapping, confirmTypeMapping } from './config'
import ButtonPackingProduk from './ButtonPackingProduk.vue'
import useOutboundOperations from './composable/useOutboundOperations'
import StatusPackingPill from '../StatusPackingPill.vue'

export default {
  name: 'DetailNonKomship',
  components: {
    Table,
    ResumeFee,
    ModalConfirm,
    ButtonPackingProduk,
    Button,
    StatusPackingPill,
  },
  data() {
    return {
      loading: true,
      orderData: {
        order_summary: [],
      },
      selectedOrder: [],
      dataUpdated: false,
      totalValidOrder: 0,
      isMutating: false,
      outboundOperations: null,
      loadingDownloadLabel: false,
    }
  },
  computed: {
    warehouseId() {
      return this.profile?.id || null
    },
    isOrderDibatalkan() {
      return this.orderData.status === 'Dibatalkan'
    },
    grandTotalOrder() {
      if (!this.dataUpdated) return 0
      return this.orderData?.order_summary?.reduce((acc, item) => acc + item.total_order, 0)
    },
    packingProductDisabled() {
      return this.selectedOrder.length === 0 || this.orderData.status !== 'Diajukan'
    },
    /**
     * Outbound header metadata summary (order date, ID, print status, batch status).
     * @type {import('vue').ComputedRef<Object>}
     */
    generalInfo() {
      const orderSummaries = this.orderData?.order_summary || []
      const nonCanceledOrder = orderSummaries.find(item => item.status !== 'Dibatalkan')
      const status = nonCanceledOrder?.status || orderSummaries[0]?.status || this.orderData?.status || 'unknown'

      const createdAt = this.orderData?.created_at
      const isValidDate = createdAt && moment(createdAt).isValid()

      return {
        order_date: isValidDate ? DAY_MONTH_YEAR(createdAt) : '-',
        order_time: isValidDate ? TIME_DOT(createdAt) : '-',
        id: this.orderData?.id || '-',
        printed_at: this.formatPrintedAt(this.orderData?.last_printed_at),
        status,
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    next()
    this.getDetailNonKomship()
  },
  async created() {
    this.outboundOperations = useOutboundOperations(this)

    if (!this.profile) {
      await this.$store.dispatch('warehouse/getWarehouseProfile')
    }
    this.getDetailNonKomship()
  },
  methods: {
    /**
     * Format label download status based on print timestamp.
     * @param {string|null} printedAt
     * @returns {string}
     */
    formatPrintedAt(printedAt) {
      if (this.loading) {
        return '-'
      }
      if (!printedAt) {
        return 'Label belum diunduh'
      }
      const date = moment(printedAt).locale('id')
      if (!date.isValid()) {
        return 'Label belum diunduh'
      }
      if (date.isSame(moment(), 'day')) {
        return `Label telah diunduh pada ${TIME_DOT(printedAt)}`
      }
      return `Label telah diunduh pada ${DAY_FULL_DATE_TIME(printedAt)}`
    },
    handleRefreshPage() {
      window.location.reload()
    },
    /**
     * Fetch outbound order details and initialize outboundOperations state.
     */
    async getDetailNonKomship() {
      this.loading = true
      try {
        const { data } = await this.$http_new.get(`/kompack/api/v1/mitra/outbounds/${this.$route.params.id}/detail`)
        this.orderData = data?.data || {}
        this.$refs.buttonPackingProduk.setOrderStatus(data?.data?.status || '')
        if (data?.data?.status === 'Dikirim') {
          this.$refs.buttonPackingProduk.setDisabled(true)
          this.$refs.resumeFee.updateResumeFee({
            originalFulfillmentFee: data?.data?.grand_fulfillment_fee || 0,
            newFulfillmentFee: 0,
            difference: 0,
            totalOrder: data?.data?.order_summary?.length || 0,
          })
        }
        this.outboundOperations.initializeState({
          totalOrder: data?.data?.order_summary?.reduce((acc, item) => {
            if (item.status !== 'Dibatalkan') {
              return acc + item.total_order
            }
            return acc
          }, 0) || 0,
          onUpdate: this.handleUpdateSelected,
        })
      } catch (error) {
        toastError('Gagal mengambil data order packing. Silahkan coba lagi.')
      } finally {
        this.loading = false
      }
    },
    /**
     * Mark print status via API and open label URL in a new tab.
     * @param {string} url
     */
    async handleDownloadLabel(url) {
      this.loadingDownloadLabel = true
      try {
        await this.$http_new.put(`/kompack/api/v1/mitra/outbounds/${this.orderData.id}/status-print`, { is_print: true })
        window.open(url, '_blank')
        await this.getDetailNonKomship()
      } catch (error) {
        toastError('Gagal mendownload label. Silahkan coba lagi.')
      } finally {
        this.loadingDownloadLabel = false
      }
    },
    /**
     * Update fulfillment fee summary when selected orders change.
     * @param {{ newFulfillmentFee: number, originalFulfillmentFee: number, orderSelected: number }} selected
     */
    handleUpdateSelected(selected) {
      const { newFulfillmentFee, originalFulfillmentFee, orderSelected } = selected
      const difference = newFulfillmentFee - originalFulfillmentFee
      if (this.orderData.status !== 'Belum Dipacking') {
        this.$refs.buttonPackingProduk.setDisabled(orderSelected === 0)
      }
      this.$refs.resumeFee.updateResumeFee({
        totalOrder: orderSelected,
        originalFulfillmentFee,
        newFulfillmentFee,
        difference,
      })
    },
    /**
     * Handle packing confirmation (shows confirmation modal on partial selection, direct mutation on full selection).
     */
    async handlePackingProduct() {
      const handleError = error => {
        this.$refs.buttonPackingProduk.setLoading(false)
        toastError('Gagal melakukan penggantian status order. Silahkan coba lagi.')
      }

      this.outboundOperations.confirmOrder({
        type: confirmTypeMapping[this.orderData.status] || 'confirm',
        mutationFn: async ({ isAllSelected, execMutation }) => {
          const modalMessage = modalMessagesMapping[this.orderData.status] || modalMessagesMapping['Belum Dipacking']

          // Case: Partial order - show confirmation modal first
          if (!isAllSelected) {
            const activeModalMessage = modalMessage[1]
            this.$refs.modalConfirm.show({
              title: activeModalMessage.title,
              description: activeModalMessage.description,
              type: activeModalMessage.type,
              confirmFn: async close => {
                try {
                  this.$refs.buttonPackingProduk.setLoading(true)
                  await execMutation()
                  close()
                  if (activeModalMessage.redirectTo) {
                    this.redirectToOutboundNonKomship(activeModalMessage.redirectTo)
                    return
                  }
                  this.getDetailNonKomship()
                } catch (error) {
                  handleError(error)
                }
              },
            })
            return
          }

          this.$refs.buttonPackingProduk.setLoading(true)
          // Case: Full order - execute mutation directly
          await execMutation()
          this.$refs.buttonPackingProduk.setLoading(false)
          const activeModalMessage = modalMessage[0]
          this.$refs.modalConfirm.show({
            title: activeModalMessage.title,
            description: activeModalMessage.description,
            type: activeModalMessage.type,
            confirmFn: close => {
              close()
              this.redirectToOutboundNonKomship(activeModalMessage.redirectTo)
            },
          })
        },
        errorFn: handleError,
      })
    },
    handleCloseModalConfirm() {
      this.$refs.buttonPackingProduk.setLoading(false)
    },
    /**
     * Redirect to non-komship outbound table with status query.
     * @param {string} status
     */
    redirectToOutboundNonKomship(status) {
      this.$router.push({
        name: 'outbound-non-komship',
        query: {
          status,
        },
      })
    },
  },
}
</script>
